import { Play } from "lucide-react";
import video1 from "@/assets/videos/neil-video-1.mp4";
import video2 from "@/assets/videos/neil-video-2.mov";
import video3 from "@/assets/videos/neil-video-3.mp4";
import video4 from "@/assets/videos/neil-video-4.mov";

const videos = [
  { src: video1, title: "AI Automation in Action" },
  { src: video2, title: "Robotics Deployment" },
  { src: video3, title: "Enterprise Operations" },
  { src: video4, title: "Workforce Empowerment" },
];

const VideoShowcase = () => {
  return (
    <section className="my-12 md:my-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/5 mb-4">
          <Play className="h-3.5 w-3.5 text-primary" />
          <span className="text-xs uppercase tracking-widest font-semibold text-primary">
            Featured Videos
          </span>
        </div>
        <h2 className="font-orbitron font-bold text-3xl md:text-5xl mb-3">
          See Neil AI <span className="text-primary">In Action</span>
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
          Cinematic looks at our AI automation systems and PUDU robotics deployments.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {videos.map((v, i) => (
          <div
            key={i}
            className="group relative rounded-2xl overflow-hidden glass-effect border border-[hsl(var(--line))] hover:border-primary/50 transition-all duration-500 shadow-[0_0_40px_hsl(var(--primary)/0.1)] hover:shadow-[0_0_60px_hsl(var(--primary)/0.3)]"
          >
            <video
              src={v.src}
              controls
              loop
              muted
              playsInline
              preload="metadata"
              className="w-full h-auto aspect-video object-cover bg-black"
            />
            <div className="p-4 border-t border-[hsl(var(--line))]">
              <h3 className="font-semibold text-base md:text-lg text-foreground">
                {v.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VideoShowcase;
